import { Type, type Static } from "@sinclair/typebox";

export const StructureYearResetSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    managementYear: Type.Literal(2027),
    expectedFingerprint: Type.String({ pattern: "^[a-f0-9]{64}$" }),
  },
  { additionalProperties: false },
);
export const StructureYearResetQuerySchema = Type.Object(
  { managementYear: Type.Integer({ minimum: 2027, maximum: 2027 }) },
  { additionalProperties: false },
);
export type StructureYearReset = Static<typeof StructureYearResetSchema>;
export interface StructureYearResetPreview {
  managementYear: 2027;
  fingerprint: string;
  eligibleCenterCount: number;
  includedCenterCount: number;
  budgetAmount: string;
  actualAmount: string;
  sourceRows: number;
  blockingReasons: string[];
  organizationPresent: boolean;
  linkedSimulatorCenters: number;
  supplierRouteCount: number;
}
export interface StructureYearResetResult {
  operationId: string;
  managementYear: 2027;
  excludedCenters: number;
  clearedSimulatorLinks: boolean;
  preservedSupplierRoutes: number;
  replayed: boolean;
}
